/**
 * ViewerSideControls — vertical control column to the right of the plan frame.
 *
 * Renders at most two stacked control groups:
 *   1. LevelToggle  — floor/tier picker; shown only for multi-level products
 *   2. ZoomControls — +/− zoom buttons; shown always once Phase C wires the
 *                     TransformWrapper bridge
 *
 * When all children are hidden (single-level product, no zoom bridge) the
 * component returns null so no dead whitespace appear in the layout.
 */
import { useProduct } from '../../../index.js'

import { useI18n } from '../../../../../shared/i18n/useI18n.js'

import { LevelToggle }  from './LevelToggle.jsx'
import { ZoomControls } from './ZoomControls.jsx'

import { Button }       from '../../../../../shared/ui/Button/Button.jsx'
import { Close }        from '../../../../../shared/ui/icons/index.js'

import styles from './ViewerSideControls.module.scss'

/**
 * @param {object}   props
 * @param {object}   [props.zoomBridgeRef]  — ref with { zoomIn, zoomOut, resetTransform }
 *   passed from PlanViewer once Phase C wires TransformWrapper; undefined = ZoomControls hidden
 */
export function ViewerSideControls({ onClose, isMobile, zoomBridgeRef }) {
  const { t } = useI18n()
  const { capabilities } = useProduct()
  
  return (
    isMobile ? (
      <div className={styles.sideControlsMobile} aria-label={undefined}>
        <div className={styles.controlContainer}>
          <span className={styles.controlLabel}>{t('common.zoom')}</span>
          <ZoomControls isMobile={isMobile} zoomBridgeRef={zoomBridgeRef} />
        </div>
        {capabilities.supportsLevelSelector &&
        <div className={styles.controlContainer}>
          <span className={styles.controlLabel}>{t('common.level')}</span>
          <LevelToggle isMobile={isMobile} />
        </div>
        }
      </div>
    ) : (
     <aside className={styles.sideControls} aria-label={undefined}>
      <Button
        type="button"
        kind="icon"
        size="large"
        cta
        onClick={onClose}
        aria-label={t('product.close_aria')}
      >
        <Close />
      </Button>
      <div className={styles.controlsBox}>
        <LevelToggle isMobile={isMobile} />
        <ZoomControls isMobile={isMobile} zoomBridgeRef={zoomBridgeRef} />
      </div>
    </aside>
    )
  )
}
